import React from 'react'
import styled from 'styled-components'

interface SwitchProps {
  checked: boolean
  onChange: (checked: boolean) => void
  disabled?: boolean
  onLabel?: string
  offLabel?: string
}

const SwitchWrapper = styled.div<{ checked: boolean; disabled?: boolean }>`
  width: 64px;
  height: 32px;
  border-radius: 16px;
  background-color: ${p => p.theme.colors.button.background};
  position: relative;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  transition: background-color 0.25s ease;
  display: flex;
  align-items: center;
  justify-content: ${({ checked }) => (checked ? 'flex-start' : 'flex-end')};
  padding: 0 4px;
  font-size: 12px;
  box-sizing: border-box;
`

const SwitchThumb = styled.div<{ checked: boolean }>`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: ${p => p.theme.colors.text.primaryDarkBackground};
  position: absolute;
  top: 4px;
  left: ${({ checked }) => (checked ? '4px' : 'calc(100% - 28px)')};
  transition: left 0.25s ease;
  z-index: 1;
`

const SwitchLabel = styled.span<{ position: 'left' | 'right'; visible: boolean }>`
  position: absolute;
  top: 50%;
  ${({ position }) => position}: 8px;
  transform: translateY(-50%);
  font-size: 20px;
  color: ${p => p.theme.colors.text.primaryDarkBackground};
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transition: opacity 0.2s ease;
  pointer-events: none;
  user-select: none;
  z-index: 2;
`

export const Switch: React.FC<SwitchProps> = ({ checked, onChange, disabled, onLabel = 'On', offLabel = 'Off' }) => {
  return (
    <SwitchWrapper
      onClick={() => !disabled && onChange(!checked)}
      onKeyDown={e => {
        if (!disabled && (e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault()
          onChange(!checked)
        }
      }}
      checked={checked}
      disabled={disabled}
    >
      <SwitchLabel position="left" visible={!checked}>
        {offLabel}
      </SwitchLabel>
      <SwitchLabel position="right" visible={checked}>
        {onLabel}
      </SwitchLabel>
      <SwitchThumb checked={checked} />
    </SwitchWrapper>
  )
}
